<template lang="pug">
div
  ul.data.registered
    space-list-subscribed-item(
      v-for='subscribedSpace in subscribedSpaces'
      v-bind:key="subscribedSpace.id"
      v-bind:initial-space="subscribedSpace"
      @toggle-follow="toggleFollow"
    )
    spaces-list-item(
      v-for='space in spaces'
      v-bind:key='space.id'
      v-bind:initial-space="space"
      @toggle-follow='toggleFollow'
    )
  infinite-loading(spinner="waveDots" @infinite="infiniteHandler")
    span(slot="no-results")
      | No results.
    span(slot="no-more")
  #error-message(v-if="errorMessage")
    | {{ errorMessage }}
</template>

<script>
import SpacesListItem from 'components/spaces/spaces_list_item.vue';
import SpaceListSubscribedItem from 'components/spaces/space_list_subscribed_item.vue';
import InfiniteLoading from 'vue-infinite-loading';
export default {
  components: {
    'spaces-list-item': SpacesListItem,
    'space-list-subscribed-item': SpaceListSubscribedItem,
    InfiniteLoading
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
      }
      return value;
    }
  },
  props: {
    spaces: {
      type: Array,
      default: () => ([])
    },
    subscribedSpaces: {
      type: Object,
      default: () => ([])
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  methods: {
    infiniteHandler: function($state) {
      this.$emit('infinite-load', $state);
    },
    toggleFollow: function(space) {
      this.$emit('toggle-follow', space);
    }
  },
};

</script>

<style scoped lang="scss">
@import "app/assets/stylesheets/_mixin.scss";
@import "app/assets/stylesheets/_variable.scss";
#error-message {
  color: #F00;
  padding-top: 150px;
  text-align: center;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.75);
  z-index: 99999;
}
#title {
  &.index {
    @include text-shadow();
    @include linear-gradient(#000, #222);
    border-left: none;
    border-right: none;
    color: #FFFFFF;
    h1 {
      padding: 10px 0;
      font-size: $common-xx-large;
      text-align: center;
      font-weight: bold;
      line-height: 1.2;
      span {
        line-height: 1.5;
        font-size: $common-large;
        display: block;
      }
    }
  }
}

.list--spaces {
  .notice {
    background-color: #FFFFBF;
    border: 2px solid #F9A01B;
    padding: 10px;
    line-height: 1.4;
    font-size: $common-normal;
    clear: both;
    a {
      text-decoration: underline;
      color: $common-blue;
    }
    .bold {
      font-weight: bold;
    }
  }
  .buttons {
    @include clearfix();
    margin-bottom: 15px;
  }
  .search-condition {
    display: none;
    clear: both;
  }
  ul.area-search {
    @include clearfix();
    margin-bottom: 15px;
    .area, .prefecture {
      line-height: 1.5;
      display: block;
      font-size: $common-normal;
      text-align: center;
    }
    .area {
      margin-bottom: 1px;
      font-weight: bold;
      font-size: $common-small;
    }
    .prefecture {
      padding: 5px;
      a {
        @include border-radius();
        font-size: 1.0rem;
        background-color: #fff;
        padding: 3px 6px;
        display: block;
        text-align: center;
        border: 1px solid #ccc;
        font-weight: bold;
        var {
          @include border-radius(10px 10px);
          font-weight: bold;
          color: #fff;
          font-size: $common-small;
          text-align: center;
          vertical-align: middle;
          padding: 0 3px;
          margin-top: -7px;
          margin-left: -9px;
          margin-right: -9px;
          float: left;
        }
        &.on {
          background-color: #fff;
          color: #000;
          &:hover {
            background-color: #f6f6f6;
          }
          var {
            background-color: $common-red;
          }
        }
        &.off {
          color: #ccc;
          background-color: #f3f3f3;
          var {
            display: none;
          }
        }
      }
    }
  }
  .data {
    @include clearfix();
    &.registered {
      .space {
        .cover {
          .image {
            img {
              width: 100%;
              display: block;
            }
          }
          .main {
            position: relative;
            .title {
              text-align: center;
              padding: 15px;
              width: 100%;
            }
            .name {
              @include ellipsis();
              width: 100%;
              display: block;
            }
            .address {
              @include ellipsis();
            }
            .type {
              position: absolute;
              margin: -28px 0 0 -20px;
            }
            .catchcopy {
              margin: 1px;
            }
          }
          .catchimage {
            background-image: none !important;
            .data {
              padding: 15px 15px 5px 15px;
              .buttons {
                margin: 0 -5px 0 -5px;
              }
              table {
                background-color: rgba(0,0,0,0.7);
              }
            }
          }
        }
        .interest {
          padding: 5px 10px;
          right: 10px;
          .watching, .favorite {
            @include border-radius(20px 20px);
            @include box-shadow();
            width: 40px;
            height: 40px;
            padding: 5px 0 7px 0;
            i.font-awesome-icon {
              padding-right: 0;
              margin-bottom: 2px;
              font-size: $common-large;
              display: block;
            }
          }
        }
      }
    }
    &.default {
      .space {
        margin-bottom: 0;
      }
    }
    .space {
      margin-bottom: 25px;
      background-color: #fff;
      background-color: #fff;
      .cover {
        border: 1px solid #ddd;
        border-top: 5px solid $common-blue;
        display: block;
        .main {
          width: 100%;
          vertical-align: middle;
          .official {
            @include text-shadow();
            background-color: #006DD9;
            font-size: $common-small;
            padding: 3px 4px 2px 4px;
            margin-top: -1px;
            display: inline-block;
            color: #fff;
            font-weight: bold;
            font-size: 1.0rem;
            vertical-align: middle;
          }
          .type {
            @include border-radius();
            background-color: $common-blue;
            color: #fff;
            padding: 5px 8px;
            font-size: 1.0rem;
            font-weight: bold;
            text-align: center;
          }
          .name, .address {
            color: #333;
            display: block;
          }
          .address {
            font-size: 1.1rem;
            color: #333;
            font-weight: bold;
            margin-top: 4px;
          }
          .name {
            font-size: 1.7rem;
            color: $common-blue;
            &:hover {
              text-decoration: underline;
            }
          }
          .place {
            @include clearfix();
            border: 1px solid $common-red;
            font-size: $common-small;
            font-weight: bold;
            margin-top: -2px;
            margin-left: 10px;
            float: right;
            .prefecture, .named {
              width: 60px;
              padding: 3px 6px;
              text-align: center;
            }
            .prefecture {
              background-color: $common-red;
              color: #fff;
            }
            .named {
              background-color: #fff;
              color: $common-red;
            }
          }
          .latest-article {
            padding: 10px 13px;
            font-size: $common-normal;
            line-height: 1.4;
            background-color: #f3f3f3;
            text-align: center;
            a {
              @include ellipsis();
              color: $common-blue;
              font-size: $common-normal;
              font-weight: bold;
              text-align: left;
              display: block;
            }
          }
        }
        .catchimage {
          @include clearfix();
          .games {
            margin-bottom: 5px;
            font-weight: bold;
            font-size: $common-normal;
            a {
              text-decoration: underline;
              color: $common-blue;
            }
          }
          .catchcopy {
            font-size: 1.2rem;
            line-height: 1.35;
            height: 6em;
            overflow: hidden;
          }
          .data {
            .logo {
              margin-bottom: 25px;
              img {
                max-height: 100px;
                display: inline-block;
              }
            }
            table {
              width: 100%;
              line-height: 1.3;
              tr {
                border-top: 1px solid rgba(255,255,255,0.4);
                &:first-child {
                  border-top: none;
                }
                th, td {
                  padding: 6px 0;
                  font-size: $common-normal;
                }
                th {
                  width: 70px;
                  font-size: $common-small;
                  padding-right: 11px;
                }
              }
            }
          }
        }
      }
      .interest {
        @include clearfix();
        position: absolute;
        .watching, .favorite {
          @include border-radius(30px 30px);
          @include box-shadow();
          font-size: $common-normal;
          background-color: #fff;
          color: #fff;
          display: block;
          text-align: center;
          font-weight: bold;
          float: left;
        }
        .watching {
          color: $icon-watching-on;
        }
        .favorite {
          margin-left: 8px;
          color: $icon-favorite-on;
        }
      }
      .playable {
        width: 100%;
        tr {
          border-top: 1px dotted #ccc;
          &:first-child {
            border-top: none;
          }
          th, td {
            padding: 6px 0;
          }
          th {
            font-size: $common-normal;
            font-weight: bold;
            width: 120px;
          }
          td {
            font-size: $common-large;
            color: $common-orange;
            i.font-awesome-icon.ban {
              color: #888;
            }
          }
        }
      }
      .option {
        @include clearfix();
        .tag-1, .tag-2, .tag-3 {
          @include border-radius(25px 25px);
          margin: 0 1%;
          padding: 7px 2px;
          font-size: 1.1rem;
          text-align: center;
          width: 18%;
          float: left;
          i.font-awesome-icon {
            display: block;
            margin-bottom: 5px;
            padding-right: 0;
            font-size: $common-x-large;
          }
        }
        .tag-1 {
          @include text-shadow();
          border: 1px solid $common-red;
          background-color: $common-red;
          color: #fff;
        }
        .tag-2 {
          border: 1px solid #333;
          background-color: #fff;
          color: #333;
        }
        .tag-3 {
          border: 1px solid #aaa;
          background-color: #eee;
          color: #999;
        }
      }
    }
  }
  ul.data.default {
    width: 100%;
    font-size: $common-normal;
    margin-bottom: 25px;
    li.header {
      border-top: 1px dotted #ccc;
      background-color: #e6e6e6;
      text-align: left;
      padding: 6px 8px;
    }
    li.empty {
      td {
        color: #888;
        padding: 15px 0;
        background-color: #fff;
      }
    }
    li.space {
      padding: 10px;
      border-bottom: 1px dotted #ccc;
      display: flex;
      align-items: center;
      .follow {
        width: 130px;
        padding-left: 0;
        .follow-buttons {
          padding-bottom: 0;
          li {
            .follow, .visited {
              font-size: $common-normal;
            }
          }
        }
      }
      .name {
        width: calc(100% - 220px - 130px);
        padding-left: 10px;
        .spacename {
          font-weight: bold;
          a {
            font-size: 1.4rem;
          }
        }
        .address {
          padding-top: 2px;
          font-size: 1.0rem;
          line-height: 1.2;
          font-weight: normal;
        }
      }
      .official {
        width: 220px;
        .social {
          margin: 0;
        }
      }
    }
  }
}

/* XSサイズ : Extra Small Devices, Phones */
@media only screen and (max-width : 767px) {
  #title {
    &.index {
      h1 {
        font-size: $common-x-large;
        span {
          margin-top: 5px;
        }
      }
    }
  }
  .list--spaces {
    .notice {
      margin-bottom: 15px;
    }
    .buttons {
      margin-top: 15px;
    }
    ul.area-search {
      li {
        @include clearfix();
        span.area {
          background-color: #f3f3f3;
          margin-top: 5px;
          padding: 4px 8px;
          font-size: $common-large;
          text-align: left;
        }
        span.prefecture {
          float: left;
          a {
            font-size: $common-large;
          }
        }
      }
    }
    table.data.default {
      width: calc(100% + 30px);
      border-top: 1px solid #ccc;
      margin: 0 -15px;
      tr {
        td.follow {
          padding-left: 10px;
        }
        th {
          padding-right: 10px;
        }
      }
    }
  }
  .list--spaces {
    .data.registered {
      padding-top: 10px;
      margin-right: 0;
      & > .space {
        margin-bottom: 15px;
        padding-right: 0 !important;
      }
    }
    ul.data.default {
      width: calc(100% + 30px);
      margin: 0 -15px;
      font-size: $common-normal;
      li.space {
        .name {
          width: calc(100% - 130px);
        }
      }
      li.empty {
        margin: 15px !important;
        padding: 15px !important;
      }
    }
  }
}

/* Sサイズ、タブレット : Small Devices, Tablets */
@media only screen and (min-width : 768px) {
  .list--spaces {
    .notice {
      margin-bottom: 15px;
    }
    ul.area-search {
      & > li {
        @include clearfix();
        width: calc(100% / 7);
        float: left;
      }
    }
    .data.registered {
      padding-top: 30px;
      margin-right: -25px;
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-wrap: wrap;
      & > .space {
        padding-right: 25px !important;
        margin-bottom: 25px;
        width: 50%;
      }
    }
  }
}

/* Mサイズ、デスクトップ : Medium Devices, Desktops */
@media only screen and (max-width : 991px) {
}

/* Mサイズ、デスクトップ : Medium Devices, Desktops */
@media only screen and (min-width : 992px) {
  .list--spaces {
    .data.registered {
    }
  }
}

/* Lサイズ、ワイドスクリーン : Large Devices, Wide Screens */
@media only screen and (min-width : 1200px) {
  .list--spaces {
    .data.registered {
      & > .space {
        width: calc(100% / 3);
      }
    }
  }
}

/* Lサイズ、ワイドスクリーン : Large Devices, Wide Screens */
@media only screen and (min-width : 1500px) {
  .controller-spaces.action-index {
    .list--spaces {
      .data.registered {
        & > .space {
          width: 25%;
        }
      }
    }
  }
}

</style>
